/**
 * Adds functionality to handle modal element
 */
class HandleModal {
  #element;
  #content;
  #handle;
  #handleLabel;
  #modalClose;
  #dimmerElement;
  #modalToggleCustomElements;
  #handleLabelTexts;
  #carSearchContainer;

  /**
   * Constructor. Starts everything up if tabs are found
   * @param {HTMLElement} element element to bind logic into
   */
  constructor(element) {
    this.#element = element;
    this.#content = this.#element.querySelector('.handle-modal__content');
    this.#handle = this.#element.querySelector('.handle-modal__handle');
    this.#handleLabel = this.#handle.querySelector('.handle-label');
    this.#modalClose = this.#element.querySelector('.handle-modal__close');
    this.#dimmerElement = document.querySelector('.handle-modal__dimmer');
    this.#modalToggleCustomElements = Array.from( document.querySelectorAll('.handle-modal-custom-toggle') );
    this.#carSearchContainer = document.querySelector('.car-search-2022');

    this.#handleLabelTexts = {
      default: this.#handleLabel?.innerText ?? 'Näytä',
      close: 'Sulje'
    };

    this._bindElements();
  }

  /**
   * Bind elements
   */
  _bindElements() {
    this.#handle.addEventListener('click', this._toggleModal.bind(this));
    this.#modalClose.addEventListener('click', this._toggleModal.bind(this, 'close'));

    this.#modalToggleCustomElements.forEach((element) => {
      element.addEventListener('click', this._toggleModal.bind(this));
    });

    this.#dimmerElement.addEventListener('click', this._toggleModal.bind(this, 'close'));
  }

  /**
   * Show/Hide modal
   * @param {String} action Optional modal show/hide action. Accepts values "open" and "close".
   */
  _toggleModal(action) {
    // Set modal content visible on first opening. Improves rendering performance to have the content hidden on load.
    if (this.#content.offsetParent === null) {
      this.#content.style.display = 'block';
    }

    let isOpen;

    if (action === 'open') {
      isOpen = this.#element.classList.add('open');
    } else if (action === 'close') {
      isOpen = this.#element.classList.remove('open');
    } else {
      isOpen = this.#element.classList.toggle('open');
    }

    if (isOpen) {
      this.#content.focus();
    } else {
      this.#carSearchContainer.focus();
    }

    // Dispatch new custom event that contains isOpen status inside details
    document.dispatchEvent(new CustomEvent('handleModalToggle', {
      detail: { isOpen }
    }));

    // Set modal handle label text
    if (isOpen) {
      this.#handleLabel.innerText = this.#handleLabelTexts.close;
      document.body.classList.add('no-scroll');
    } else {
      this.#handleLabel.innerText = this.#handleLabelTexts.default;
      document.body.classList.remove('no-scroll');
    }
  }

  /**
   * init Static initializer of the class.
   */
  static init() {
    const handleModal = document.querySelector('.handle-modal');

    if (handleModal) {
      new HandleModal(handleModal);
    }
  }
}

export default HandleModal;
